import { CustomAppLayout } from '../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect } from 'react';
import { useGlobalState } from '../../context/GlobalStateContext';
import { useRouter } from '../router';
const _preserve = React.version;



import { Box, Link, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiAlertOctagon } from '@mdi/js';
import { Icon } from '@mdi/react';
import React from 'react';
import { buildBreadcrumbItems, getParameter } from '../../commons/functions';



export const Page404 = () => {
    //const storeAdmin = useStoreAdmin();
    const { menu } = useGlobalState();

    const { navigate } = useRouter();




    useEffect(() => {
    }, []);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s" direction='vertical' alignItems='center'>
                    <Header variant="h1">ERROR 404</Header>
                    <Icon path={mdiAlertOctagon} size={6} color={"red"} />
                    <Header variant="h3"><Link variant="secondary" onClick={() =>
                        window.location.hash = getParameter(window.location.hash, "route")
                    }>Recurso no se encuentra disponible</Link></Header>
                    <Box>x-Route: {getParameter(window.location.hash, "route")}</Box>
                </SpaceBetween>
            }
        />
    );
};
